import { url } from "./apiurl";

async function read(path, signal) {
  const response = await fetch(`${url}/ajman-media-city/${path}`, { signal });
  if (!response.ok) {
    const error = new Error(response.status === 404 ? "This page is currently unavailable." : "Unable to load Ajman Media City Packages. Please try again.");
    error.status = response.status;
    throw error;
  }
  const data = await response.json();
  if (!data || !Array.isArray(data.products)) throw new Error("Unable to load Ajman Media City Packages. Please try again.");
  return data;
}
export const ajmanMediaCityApi = {
  home: (tab, signal) => read(`home?tab=${tab}`, signal),
  page: (page, tab, signal) => read(`page?tab=${tab}&page=${page}&limit=12`, signal),
  all: async (tab, signal) => {
    const first = await read(`page?tab=${tab}&page=1&limit=100`, signal);
    const rest = await Promise.all(Array.from({ length: Math.max(0, first.pages - 1) },
      (_, index) => read(`page?tab=${tab}&page=${index + 2}&limit=100`, signal)));
    return { ...first, products: [first, ...rest].flatMap(result => result.products) };
  },
};
